/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { BancoGetQuery } from '../models/banco-get-query';
import { BancoViewModel } from '../models/banco-view-model';
import { DownloadFilePaymentLotCommand } from '../models/download-file-payment-lot-command';
import { DownloadResultsPaymentLotCommand } from '../models/download-results-payment-lot-command';
import { PaymentChannelViewModel } from '../models/payment-channel-view-model';
import { PaymentLotBase } from '../models/payment-lot-base';
import { PaymentLotViewModel } from '../models/payment-lot-view-model';
import { ProcessPaymentLotCommand } from '../models/process-payment-lot-command';

@Injectable({ providedIn: 'root' })
export class PaymentLotService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPaymentLotIdGet()` */
  static readonly ApiPaymentLotIdGetPath = '/api/PaymentLot/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotIdGet$Plain$Response(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PaymentLotViewModel>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentLotViewModel>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotIdGet$Plain(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<PaymentLotViewModel> {
    return this.apiPaymentLotIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentLotViewModel>): PaymentLotViewModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotIdGet$Json$Response(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PaymentLotViewModel>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentLotViewModel>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotIdGet$Json(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<PaymentLotViewModel> {
    return this.apiPaymentLotIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentLotViewModel>): PaymentLotViewModel => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotGet()` */
  static readonly ApiPaymentLotGetPath = '/api/PaymentLot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotGet$Plain$Response(
    params?: {
      Search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PaymentLotViewModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PaymentLotViewModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotGet$Plain(
    params?: {
      Search?: string;
    },
    context?: HttpContext
  ): Observable<Array<PaymentLotViewModel>> {
    return this.apiPaymentLotGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentLotViewModel>>): Array<PaymentLotViewModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotGet$Json$Response(
    params?: {
      Search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PaymentLotViewModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PaymentLotViewModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotGet$Json(
    params?: {
      Search?: string;
    },
    context?: HttpContext
  ): Observable<Array<PaymentLotViewModel>> {
    return this.apiPaymentLotGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentLotViewModel>>): Array<PaymentLotViewModel> => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotDelete()` */
  static readonly ApiPaymentLotDeletePath = '/api/PaymentLot';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotDelete$Plain$Response(
    params?: {
      id?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotDeletePath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotDelete$Plain(
    params?: {
      id?: string;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.apiPaymentLotDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotDelete$Json$Response(
    params?: {
      id?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotDeletePath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotDelete$Json(
    params?: {
      id?: string;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.apiPaymentLotDelete$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotUploadTemplatePost()` */
  static readonly ApiPaymentLotUploadTemplatePostPath = '/api/PaymentLot/uploadTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotUploadTemplatePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPaymentLotUploadTemplatePost$Plain$Response(
    params?: {
      IPConsulta?: string;
      RequestConsulta?: string;
      PaymentChannelId?: number;
      Reference?: string;
      body?: {
'File'?: Blob;
}
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PaymentLotBase>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotUploadTemplatePostPath, 'post');
    if (params) {
      rb.query('IPConsulta', params.IPConsulta, {});
      rb.query('RequestConsulta', params.RequestConsulta, {});
      rb.query('PaymentChannelId', params.PaymentChannelId, {});
      rb.query('Reference', params.Reference, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentLotBase>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotUploadTemplatePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPaymentLotUploadTemplatePost$Plain(
    params?: {
      IPConsulta?: string;
      RequestConsulta?: string;
      PaymentChannelId?: number;
      Reference?: string;
      body?: {
'File'?: Blob;
}
    },
    context?: HttpContext
  ): Observable<PaymentLotBase> {
    return this.apiPaymentLotUploadTemplatePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentLotBase>): PaymentLotBase => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotUploadTemplatePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPaymentLotUploadTemplatePost$Json$Response(
    params?: {
      IPConsulta?: string;
      RequestConsulta?: string;
      PaymentChannelId?: number;
      Reference?: string;
      body?: {
'File'?: Blob;
}
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PaymentLotBase>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotUploadTemplatePostPath, 'post');
    if (params) {
      rb.query('IPConsulta', params.IPConsulta, {});
      rb.query('RequestConsulta', params.RequestConsulta, {});
      rb.query('PaymentChannelId', params.PaymentChannelId, {});
      rb.query('Reference', params.Reference, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentLotBase>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotUploadTemplatePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPaymentLotUploadTemplatePost$Json(
    params?: {
      IPConsulta?: string;
      RequestConsulta?: string;
      PaymentChannelId?: number;
      Reference?: string;
      body?: {
'File'?: Blob;
}
    },
    context?: HttpContext
  ): Observable<PaymentLotBase> {
    return this.apiPaymentLotUploadTemplatePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentLotBase>): PaymentLotBase => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotDownloadTemplatePost()` */
  static readonly ApiPaymentLotDownloadTemplatePostPath = '/api/PaymentLot/downloadTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotDownloadTemplatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotDownloadTemplatePost$Response(
    params?: {
      body?: DownloadFilePaymentLotCommand
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotDownloadTemplatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotDownloadTemplatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotDownloadTemplatePost(
    params?: {
      body?: DownloadFilePaymentLotCommand
    },
    context?: HttpContext
  ): Observable<void> {
    return this.apiPaymentLotDownloadTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotProcessPost()` */
  static readonly ApiPaymentLotProcessPostPath = '/api/PaymentLot/process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotProcessPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotProcessPost$Plain$Response(
    params?: {
      body?: ProcessPaymentLotCommand
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotProcessPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotProcessPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotProcessPost$Plain(
    params?: {
      body?: ProcessPaymentLotCommand
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.apiPaymentLotProcessPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotProcessPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotProcessPost$Json$Response(
    params?: {
      body?: ProcessPaymentLotCommand
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotProcessPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotProcessPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotProcessPost$Json(
    params?: {
      body?: ProcessPaymentLotCommand
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.apiPaymentLotProcessPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotResultsPost()` */
  static readonly ApiPaymentLotResultsPostPath = '/api/PaymentLot/results';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotResultsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotResultsPost$Response(
    params?: {
      body?: DownloadResultsPaymentLotCommand
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotResultsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotResultsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentLotResultsPost(
    params?: {
      body?: DownloadResultsPaymentLotCommand
    },
    context?: HttpContext
  ): Observable<void> {
    return this.apiPaymentLotResultsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotBancosGet()` */
  static readonly ApiPaymentLotBancosGetPath = '/api/PaymentLot/bancos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotBancosGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotBancosGet$Plain$Response(
    params?: {
      request?: BancoGetQuery;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<BancoViewModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotBancosGetPath, 'get');
    if (params) {
      rb.query('request', params.request, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BancoViewModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotBancosGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotBancosGet$Plain(
    params?: {
      request?: BancoGetQuery;
    },
    context?: HttpContext
  ): Observable<Array<BancoViewModel>> {
    return this.apiPaymentLotBancosGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BancoViewModel>>): Array<BancoViewModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotBancosGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotBancosGet$Json$Response(
    params?: {
      request?: BancoGetQuery;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<BancoViewModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotBancosGetPath, 'get');
    if (params) {
      rb.query('request', params.request, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BancoViewModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotBancosGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotBancosGet$Json(
    params?: {
      request?: BancoGetQuery;
    },
    context?: HttpContext
  ): Observable<Array<BancoViewModel>> {
    return this.apiPaymentLotBancosGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BancoViewModel>>): Array<BancoViewModel> => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotCuentasGet()` */
  static readonly ApiPaymentLotCuentasGetPath = '/api/PaymentLot/cuentas';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotCuentasGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCuentasGet$Plain$Response(
    params?: {
      BankCode?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotCuentasGetPath, 'get');
    if (params) {
      rb.query('BankCode', params.BankCode, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotCuentasGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCuentasGet$Plain(
    params?: {
      BankCode?: string;
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.apiPaymentLotCuentasGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotCuentasGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCuentasGet$Json$Response(
    params?: {
      BankCode?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotCuentasGetPath, 'get');
    if (params) {
      rb.query('BankCode', params.BankCode, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotCuentasGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCuentasGet$Json(
    params?: {
      BankCode?: string;
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.apiPaymentLotCuentasGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotCanalesGet()` */
  static readonly ApiPaymentLotCanalesGetPath = '/api/PaymentLot/canales';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotCanalesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCanalesGet$Plain$Response(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PaymentChannelViewModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotCanalesGetPath, 'get');
    if (params) {
      rb.query('BankCode', params.BankCode, {});
      rb.query('BankAccount', params.BankAccount, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PaymentChannelViewModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotCanalesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCanalesGet$Plain(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<Array<PaymentChannelViewModel>> {
    return this.apiPaymentLotCanalesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentChannelViewModel>>): Array<PaymentChannelViewModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotCanalesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCanalesGet$Json$Response(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PaymentChannelViewModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotCanalesGetPath, 'get');
    if (params) {
      rb.query('BankCode', params.BankCode, {});
      rb.query('BankAccount', params.BankAccount, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PaymentChannelViewModel>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotCanalesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotCanalesGet$Json(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<Array<PaymentChannelViewModel>> {
    return this.apiPaymentLotCanalesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentChannelViewModel>>): Array<PaymentChannelViewModel> => r.body)
    );
  }

  /** Path part for operation `apiPaymentLotTipoCreditosGet()` */
  static readonly ApiPaymentLotTipoCreditosGetPath = '/api/PaymentLot/tipoCreditos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotTipoCreditosGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotTipoCreditosGet$Plain$Response(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotTipoCreditosGetPath, 'get');
    if (params) {
      rb.query('BankCode', params.BankCode, {});
      rb.query('BankAccount', params.BankAccount, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotTipoCreditosGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotTipoCreditosGet$Plain(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.apiPaymentLotTipoCreditosGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentLotTipoCreditosGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotTipoCreditosGet$Json$Response(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, PaymentLotService.ApiPaymentLotTipoCreditosGetPath, 'get');
    if (params) {
      rb.query('BankCode', params.BankCode, {});
      rb.query('BankAccount', params.BankAccount, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPaymentLotTipoCreditosGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPaymentLotTipoCreditosGet$Json(
    params?: {
      BankCode?: string;
      BankAccount?: string;
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.apiPaymentLotTipoCreditosGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

}
